// lib/events.ts
import mitt from 'mitt';
import { useEffect, useCallback } from 'react';

// Define your events and their payload types here
type Events = {
  "add-comment": any;
  "add_pin": any;
  "cancel_space_generation": any;
  "compose-new-email": any;
  "compose-new-sms": any;
  "create-new-content": any;
  "create_new_feature": any;
  "create_or_update_vendor": any;
  "crm_address_update": any;
  "crm_contact_remove": any;
  "crm_contact_update": any;
  "crm_occupancy_update": any;
  "crm_parcel_update": any;
  "crm_profile_merge": any;
  "crm_profile_remove": any;
  "crm_profile_update": any;
  "crm_property_remove": any;
  "crm_property_update": any;
  "crm_unit_update": any;
  "delete_app_notification": any;
  "edit_feature_boundary": any;
  "enable_media_select": any;
  "feature_added": any;
  "feature_edited": any;
  "feature_updated": any;
  "log_event_volunteer_hours": any;
  "marker_click_override": any;
  "media_select_finished": any;
  "member-deleted": any;
  "member-updated": any;
  "move_feature": any;
  "new-listing-added": any;
  "new_feature_group": any;
  "on_new_topic": any;
  "on_new_topic_error": any;
  "pending-member-approved": any;
  "pending-member-rejected": any;
  "pin-content": any;
  "redraw_boundary": any;
  "request-access": any;
  "route_directions_added": any;
  "route_directions_state": any;
  "set_map_bounds": any;
  "set_map_center": any;
  "set_marker_click_override": any;
  "set_selected_draw_feature": any;
  "set_waypoint_profile": any;
  "submission-flow": any;
  "use-position": any;
};

const emitter = mitt<Events>();

export function emitEvent<K extends keyof Events>(event: K, data: Events[K]) {
  emitter.emit(event, data);
}

export function useEventListener<K extends keyof Events>(
  event: K,
  callback: (data: Events[K]) => void
) {
  const stableCallback = useCallback(callback, [callback]);

  useEffect(() => {
    emitter.on(event, stableCallback);
    return () => emitter.off(event, stableCallback);
  }, [event, stableCallback]);
}

export default emitter;